import React, { useState } from 'react';
import styles from './AddObject.module.css';
import ModalInputField from 'components/shared/modal/ModalInputField';
import ModalDropdown from 'components/shared/modal/ModalDropdown';
import SwitchButton from './SwitchButton';
import { TrashCanIcon } from 'features/compositions/assets/icons/icons';
import { ArrowLeftClassic } from 'assets/icons';

const AddObject = ({ dataTypes, setDataTypes, setView, setCustomTypes, customTypes = [] }) => {
    const [objectName, setObjectName] = useState('');
    const [fields, setFields] = useState([
        { name: '', type: '', is_array: false }
    ]);

    const handleAddField = () => {
        setFields([...fields, { name: '', type: '', is_array: false }]);
    };

    const handleFieldChange = (index, key, value) => {
        const updatedFields = [...fields];
        updatedFields[index][key] = value;
        setFields(updatedFields);
    };

    const handleRemoveField = (index) => {
        const updatedFields = fields.filter((_, i) => i !== index);
        setFields(updatedFields);
    };

    const handleCreateObject = () => {
        if (!objectName || fields.some(f => !f.name || !f.type)) {
            alert('Please fill in all fields');
            return;
        }

        setDataTypes(prev => {
            const alreadyExists = prev.some(dt => dt.value === objectName);
            if (!alreadyExists) {
                return [...prev, { value: objectName, label: objectName }];
            }
            return prev;
        });

        setCustomTypes(prev => [...prev, {
            name: objectName,
            description: '',
            fields: fields.map(f => ({
                ...f,
                description: '',
                ...(f.type === 'time_point' && {
                    is_auto_created: false,
                    is_auto_updated: false
                })
            }))
        }]);


        setObjectName('');
        setFields([{ name: '', type: '', is_array: false }]);
        setView("records");
    };


    return (
        <div className={styles.add_object}>
            <ModalInputField
                placeholder="Object name"
                value={objectName}
                setValue={setObjectName}
            />

            <div className={styles.object_keys}>
                {fields.map((field, idx) => (
                    <div key={idx} className={styles.object_key_details}>
                        <ModalInputField
                            placeholder="Object key"
                            value={field.name}
                            setValue={(val) => handleFieldChange(idx, 'name', val)}
                        />

                        <ModalDropdown
                            title={field.type || 'Select type'}
                            options={dataTypes}
                            setOption={(val) => {
                                const selectedType = typeof val === 'object' ? val.value : val;
                                handleFieldChange(idx, 'type', selectedType);
                            }}
                        />

                        <div className={styles.detail_group}>
                            <span>Array</span>
                            <SwitchButton
                                checked={field.is_array}
                                onChange={() =>
                                    handleFieldChange(idx, 'is_array', !field.is_array)
                                }
                            />
                        </div>

                        <button
                            className={styles.delete_key}
                            onClick={() => handleRemoveField(idx)}
                        >
                            <TrashCanIcon />
                        </button>
                    </div>
                ))}
            </div>

            <div className={styles.bottom_line}>
                <button onClick={() => setView("records")}><ArrowLeftClassic /> Go back</button>
                <div className={styles.object_actions}>
                    <button onClick={handleAddField}>Add key</button>
                    <button onClick={handleCreateObject}>Create object</button>
                </div>
            </div>
        </div>
    );
};

export default AddObject;
